import React, { useContext, useEffect, useRef, useState } from "react";
import Form from "../../components/form";
import { CheckListContext } from "../../utils/checkListContext";
import { useQuery } from "../../utils/useQuery";
import { usePost } from "../../utils/usePost";
import { usePostChecklistBE } from "../../utils/usePostChecklistBE";
import uploadFileToBlob from "../../utils/azureStorageBlob";
import { API_BASE_URL, API_ROUTES } from "../../config";
import StepBar from "../../components/stepBar";
import UserNewCheckQuestions from "./userNewCheckQuestions";
import { omit } from "lodash";
import Loader from "../../components/Loader/Loader";
import Swal from "sweetalert2";
import ModalWrapper from "../../components/previewModal";

const ProgressSteps = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [step, setStep] = useState([]);
  const [status, setStatus] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [post, setPost] = useState({});
  const [imageName, setIMageName] = useState("");
  const [imageUpload, setImageUpload] = useState([]);
  const [blobList, setBlobList] = useState([]);
  const ref = useRef(false);
  const isFirstRender = useRef(true);

  const {
    errors,
    setErrors,
    checklistData,
    totalQuestions,
    tempJSON,
    setTempJSON,
    ratingMetadata,
  } = useContext(CheckListContext);

  let errorReturn = {};
  let errorObj = errors || {};

  const queryParams = useQuery();
  const lang = queryParams.get("lang");
  const product_id = queryParams.get("product_id");
  const userid = queryParams.get("userid");
  const product_Name = queryParams.get("product_name");
  const model_no = queryParams.get("model_no");
  const year = queryParams.get("year");

  let fields = {
    tableName: "submission",
    fields: {
      User_ID: "",
      Response: "",
    },
  };

  const [postHandler, submitting, postError, success] = usePost();
  const [postData, postFn, submittingBE, postStatus] = usePostChecklistBE(
    `${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_ROUTE}`,
  );

  useEffect(() => {
    let steps = step;
    let categoryNameArray = [];
    let stepId = 0;
    if (checklistData && Array.isArray(checklistData)) {
      for (var i = 0; i < checklistData.length; i++) {
        if (!categoryNameArray.includes(checklistData[i].cat)) {
          steps = [...steps, { step: stepId + 1, label: checklistData[i].cat }];
          stepId++;
        }
        categoryNameArray = [...categoryNameArray, checklistData[i].cat];
      }
    }
    setStep(steps);
  }, [checklistData]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      ref.current = false;
    } else {
      let postBody = {
        user_id: userid,
        inventory_id: product_id,
        checklist: tempJSON,
        rating_metadata: ratingMetadata,
        approver_phone: 1234567889,
        remarks: remarks,
        images: blobList,
        review_status: false,
        product_name: product_Name,
        model_no: model_no,
        year: year,
        link_type: "Mech",
      };

      let fields = {
        tableName: "submission",
        fields: {
          User_ID: userid,
          Response: JSON.stringify(tempJSON),
          Rating_Metadata: JSON.stringify(ratingMetadata),
          Product_Id: product_id,
          Product_Name: product_Name,
          Generated_Link: `${window.location.protocol}//${window.location.hostname}/techCheckList?userid=${userid}&product_id=${product_id}&product_name=${product_Name}&model_no=${model_no}&year=${year}`,
        },
      };

      if (postBody?.images?.length > 0) {
        //console.log("postBodywith",postBody);
        postFn(postBody);
        postHandler(fields);
      }
    }
  }, [blobList]);

  useEffect(() => {
    if (postStatus && postData) {
      Swal.fire({
        icon: "success",
        confirmButtonColor: "#652078",
        text: `Successfully Submitted`,
      }).then((res) => {
        if (res) {
          window.close();
          //handleRedirect();
        }
      });
    } else if (!postStatus && postData) {
      Swal.fire({
        icon: "error",
        text: postData?.data?.message,
      }).then((res) => {
        if (res) {
          //navigate(`/`);
        }
      });
    }
  }, [postData]);

  //console.log(step)
  const validateQuestions = (event, name, value, field) => {
    let rangeObj = field["range"];
    if (rangeObj !== "-" && rangeObj) {
      rangeObj = JSON?.parse(rangeObj);
    } else {
      rangeObj = "";
    }
    if (field.mandatory && field.visibility) {
      if (value === "") {
        errorObj = { ...errorObj, [name]: "It is mandatory" };
      } else if (
        value !== "" &&
        !isNaN(value) &&
        rangeObj &&
        (value < rangeObj?.["min"] || value > rangeObj?.["max"])
      ) {
        errorObj = {
          ...errorObj,
          [name]: `Range should be between ${rangeObj?.["min"]} to ${rangeObj?.["max"]}`,
        };
      } else if (
        value !== "" &&
        !isNaN(value) &&
        rangeObj &&
        !/^[0-9]*\.?\d{1,2}$/.test(value)
      ) {
        // console.log("helo3",name, value, !isNaN(value),"value",value)
        errorObj = { ...errorObj, [name]: `Please fill valid number` };
      } else if (errorObj?.hasOwnProperty(name)) {
        let newObj = omit(errorObj, name);
        errorObj = newObj;
      }
    }
    return errorObj;
  };

  const nextStep = (e) => {
    // console.log(tempJSON,errors,step)
    var defaultJsonKey = Object.keys(tempJSON || {});
    for (var i = 0; i < defaultJsonKey.length; i++) {
      if (tempJSON[defaultJsonKey[i]] === "") {
        let id = Number(defaultJsonKey[i]);
        let qField = "";
        (checklistData || []).filter((item) => {
          if (
            item.id === id &&
            (step || []).filter(
              (stepItem) =>
                item.cat === stepItem["label"] &&
                activeStep === stepItem["step"] &&
                item,
            ).length > 0
          ) {
            qField = item;
          }
        });
        errorReturn = validateQuestions(
          e,
          defaultJsonKey[i],
          tempJSON[defaultJsonKey[i]],
          qField,
          errorObj,
        );
      }
    }
    setErrors(errorReturn);
    if (errorReturn && Object.keys(errorReturn || {}).length === 0) {
      activeStep !== totalSteps && setActiveStep(activeStep + 1);
      if (activeStep === totalSteps) {
        setStatus(true);
        (imageUpload || []).length > 0 && uploadimage();
        let tempJSONVar = tempJSON;
        // tempJSONVar = {...tempJSONVar, remarks: remarks, image: imageName}
        tempJSONVar = { ...tempJSONVar };
        fields = {
          tableName: "submission",
          fields: {
            User_ID: userid,
            Response: JSON.stringify(tempJSONVar),
            Rating_Metadata: JSON.stringify(ratingMetadata),
            Product_Id: product_id,
            Product_Name: product_Name,
            Generated_Link: `${window.location.protocol}//${window.location.hostname}/techCheckList?userid=${userid}&product_id=${product_id}&product_name=${product_Name}&model_no=${model_no}&year=${year}`,
          },
        };
        let postBody = {
          user_id: userid,
          inventory_id: product_id,
          checklist: tempJSONVar,
          rating_metadata: ratingMetadata,
          approver_phone: 1234567889,
          remarks: remarks,
          images: blobList,
          review_status: false,
          product_name: product_Name,
          model_no: model_no,
          year: year,
          link_type: "Mech",
        };

        setPost(postBody);
        setTempJSON(tempJSONVar);
        if ((imageUpload || []).length === 0) {
          postFn(postBody);
          postHandler(fields);
        }
      }
    }
  };

  const prevStep = () => {
    setActiveStep(activeStep - 1);
    setStatus(false);
    setErrors({});
  };

  let fileObj = [];
  let fileArray = [];

  const uploadimage = async () => {
    const containerName = `${userid}/${product_id}`;
    let bloblistConatiner = "";
    (imageUpload || []).map(async (item) => {
      bloblistConatiner = await uploadFileToBlob(item, containerName);
      (bloblistConatiner || "").length > 0 &&
        setBlobList((prev) => [...prev, bloblistConatiner]);
    });
  };

  const handleUploadImages = (e) => {
    fileObj.push(e.target.files);
    for (let i = 0; i < fileObj[0].length; i++) {
      fileArray.push(fileObj[0][i]);
    }
    setImageUpload(fileArray);
  };

  const totalSteps = (step || []).length;

  const width = `${(100 / (totalSteps - 1)) * (activeStep - 1)}%`;

  return (
    <StepBar>
      <StepBar.StepContainer width={width}>
        {step.map(
          ({ step, label }) =>
            label !== "" && (
              <StepBar.StepWrapper key={step}>
                <StepBar.StepStyle
                  step={activeStep >= step ? "completed" : "incomplete"}
                >
                  <StepBar.StepCount>{step}</StepBar.StepCount>
                </StepBar.StepStyle>
              </StepBar.StepWrapper>
            ),
        )}
      </StepBar.StepContainer>
      {step.map(
        ({ step, label }) =>
          activeStep === step && (
            <StepBar.StepContentContainer key={step.length + step}>
              <StepBar.StepTitleContainer>
                <StepBar.StepTitle>{label}</StepBar.StepTitle>
                <StepBar.CountText>
                  {totalQuestions[label]} Questions
                </StepBar.CountText>
              </StepBar.StepTitleContainer>
              <div>
                <UserNewCheckQuestions
                  tableName={label}
                  status={status}
                  validateQuestions={validateQuestions}
                />
              </div>
              {activeStep === totalSteps && (
                <>
                  <br />
                  <Form.GroupFields>
                    <Form.Label>Remarks</Form.Label>
                    <Form.Textarea
                      cols="50"
                      rows="10"
                      disabled={status ? true : false}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                  </Form.GroupFields>
                  <br />
                  <Form.GroupFields>
                    <Form.Label>Image Upload</Form.Label>
                    <Form.Input
                      type="file"
                      name="image_upload"
                      id="image_upload"
                      multiple
                      disabled={status ? true : false}
                      onChange={(e) => handleUploadImages(e)}
                    />
                  </Form.GroupFields>
                  <br />
                </>
              )}
            </StepBar.StepContentContainer>
          ),
      )}
      <div style={{ height: "50px" }}></div>
      <StepBar.ButtonsContainer>
        {activeStep !== 1 ? (
          <StepBar.ButtonStyle
            onClick={prevStep}
            disabled={status ? true : false}
          >
            Previous
          </StepBar.ButtonStyle>
        ) : (
          <div></div>
        )}

        <StepBar.ButtonStyle
          onClick={nextStep}
          disabled={
            status ? true : Object.keys(errors || {}).length > 0 ? true : false
          }
        >
          {activeStep === totalSteps ? "Submit" : "Next"}
        </StepBar.ButtonStyle>
      </StepBar.ButtonsContainer>
      {submittingBE && (
        <ModalWrapper>
          {" "}
          <Loader />{" "}
        </ModalWrapper>
      )}
    </StepBar>
  );
};

export default ProgressSteps;
